import { MethodInstall } from "../../utils";
import ContextMenu from "./src/index.js";

export default MethodInstall(ContextMenu, "ContextMenu");
